(function () {
  'use strict';

  if (window.__chaoyangDomesticReferenceOnly) {
    window.__chaoyangDomesticReferenceOnly.start();
    return;
  }

  var MAX_AGE = 604800000;
  var initialized = new WeakMap();
  var references = [];

  function positiveInteger(value) {
    if (!/^[1-9]\d*$/.test(String(value))) return NaN;
    var number = Number(value);
    return Number.isSafeInteger(number) ? number : NaN;
  }

  function monotonicNow() {
    var value = window.performance && typeof window.performance.now === 'function'
      ? window.performance.now() : NaN;
    return Number.isFinite(value) && value >= 0 ? value : NaN;
  }

  function currentTime(state) {
    var monotonic = monotonicNow();
    var wall = Date.now();
    if (!Number.isFinite(state.server) || !Number.isFinite(state.started) ||
        !Number.isFinite(monotonic) || monotonic < state.lastMonotonic ||
        !Number.isFinite(wall)) return NaN;
    state.lastMonotonic = monotonic;
    // Use server time plus elapsed time even if the device clock moves backward.
    state.lastNow = Math.max(state.lastNow, wall, state.server + monotonic - state.started);
    return state.lastNow;
  }

  function remaining(row, now) {
    var verified = positiveInteger(row.getAttribute('data-verified-epoch')) * 1000;
    var until = positiveInteger(row.getAttribute('data-valid-until')) * 1000;
    if (!Number.isSafeInteger(verified) || !Number.isSafeInteger(until) ||
        !Number.isFinite(now) || verified > now || until - verified !== MAX_AGE) return -1;
    return until - now;
  }

  function scopeFor(reference) {
    return reference.closest('[data-cro-product]') ||
      reference.closest('.shopify-section') || reference.parentElement;
  }

  function contextMatches(state) {
    var reference = state.reference;
    if (reference.getAttribute('data-reference-type') !== state.type ||
        reference.getAttribute('data-own-price-cents') !== state.ownText ||
        reference.getAttribute('data-variant-id') !== state.variant ||
        reference.getAttribute('data-own-available') !== state.available) return false;

    if (state.type === 'quote') {
      return state.ownText === '0' && state.variant === '' && state.available === 'unknown';
    }
    if (state.type !== 'normal' || !Number.isFinite(state.own) ||
        !/^[1-9]\d*$/.test(String(state.variant)) ||
        (state.available !== 'true' && state.available !== 'false') ||
        !state.scope || !state.scope.contains(reference) ||
        scopeFor(reference) !== state.scope) return false;

    var fields = state.scope.querySelectorAll('[name="id"]');
    // Sold-out product markup has no purchase form; available products must have one.
    if (state.available === 'true' && !fields.length) return false;
    return Array.prototype.every.call(fields, function (field) {
      return String(field.value) === state.variant;
    });
  }

  function clearTimer(state) {
    if (state.timer !== null) window.clearTimeout(state.timer);
    state.timer = null;
  }

  function removeReference(state) {
    clearTimer(state);
    state.removed = true;
    state.reference.remove();
  }

  function revalidate(state) {
    clearTimer(state);
    if (state.removed) {
      state.reference.remove();
      return false;
    }
    if (!state.reference.isConnected) {
      state.removed = true;
      return false;
    }
    var now = currentTime(state);
    if (!Number.isFinite(now) || !contextMatches(state)) {
      removeReference(state);
      return false;
    }

    var count = 0;
    var next = Infinity;
    Array.prototype.forEach.call(state.reference.querySelectorAll('[data-domestic-reference-row]'), function (row) {
      var left = remaining(row, now);
      var price = positiveInteger(row.getAttribute('data-price-cents'));
      if (left <= 0 || !Number.isFinite(price)) {
        row.remove();
        return;
      }
      count++;
      next = Math.min(next, left);
    });
    if (!count) {
      removeReference(state);
      return false;
    }

    // The deadline itself is expired. Rounding up avoids zero-delay timer loops.
    state.timer = window.setTimeout(function () {
      if (!revalidate(state)) {
        references = references.filter(function (entry) { return entry !== state; });
      }
    }, Math.max(1, Math.ceil(next)));
    return true;
  }

  function initReference(reference) {
    if (initialized.has(reference)) {
      if (initialized.get(reference).removed) reference.remove();
      return;
    }
    var started = monotonicNow();
    var state = {
      reference: reference,
      scope: scopeFor(reference),
      type: reference.getAttribute('data-reference-type'),
      ownText: reference.getAttribute('data-own-price-cents'),
      own: positiveInteger(reference.getAttribute('data-own-price-cents')),
      variant: reference.getAttribute('data-variant-id'),
      available: reference.getAttribute('data-own-available'),
      server: positiveInteger(reference.getAttribute('data-server-epoch')) * 1000,
      started: started,
      lastMonotonic: started,
      lastNow: 0,
      removed: false,
      timer: null
    };
    if (!Number.isSafeInteger(state.server)) state.server = NaN;
    initialized.set(reference, state);
    references.push(state);
  }

  function init(root) {
    if (root.matches && root.matches('[data-domestic-reference]')) initReference(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-domestic-reference]'), initReference);
    }
  }

  function recheckAll() {
    references = references.filter(revalidate);
  }

  function start() {
    if (document.readyState === 'loading') return;
    init(document);
    recheckAll();
  }

  window.__chaoyangDomesticReferenceOnly = { start: start };
  document.addEventListener('DOMContentLoaded', start, { once: true });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    recheckAll();
  });
  document.addEventListener('visibilitychange', recheckAll);
  window.addEventListener('pageshow', recheckAll);
  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[name="id"]')) return;
    references = references.filter(function (state) {
      if (state.type === 'normal' && state.scope && state.scope.contains(event.target)) {
        removeReference(state);
        return false;
      }
      return true;
    });
  }, true);
  start();
}());
